import { atom } from 'jotai';

/**
 * Refcount of mounted `ProjectsArtifactCanvasHost` instances. Placement uses
 * `count > 0` so Voice only takes `projects-lhs` when a host can paint; nested
 * Work hosts (routines / detail) may stack, so a boolean would race on unmount.
 */
export const voiceProjectsLhsHostCountAtom = atom(0);
